import React from 'react';

const AlphabeticalSections = ({ 
  contacts = [],
  renderContact,
  className = ''
}) => {
  // Group contacts by first letter
  const groupedContacts = contacts?.reduce((groups, contact) => {
    const firstLetter = contact?.name?.charAt(0)?.toUpperCase();
    const letter = /[A-Z]/?.test(firstLetter) ? firstLetter : '#';
    
    if (!groups?.[letter]) {
      groups[letter] = [];
    }
    groups?.[letter]?.push(contact);
    
    return groups;
  }, {});

  // Sort groups alphabetically, with # at the end
  const sortedGroups = Object.keys(groupedContacts)?.sort((a, b) => {
    if (a === '#') return 1;
    if (b === '#') return -1;
    return a?.localeCompare(b);
  });

  if (sortedGroups?.length === 0) {
    return null;
  }

  return (
    <div className={className}>
      {sortedGroups?.map(letter => (
        <div key={letter} className="mb-6">
          {/* Section Header */}
          <div className="sticky top-16 lg:top-20 z-10 bg-background/95 backdrop-blur-sm border-b border-border py-2 mb-4">
            <h3 className="text-lg font-semibold text-text-primary px-4 lg:px-6">
              {letter}
            </h3>
          </div>
          
          {/* Contacts in this section */}
          <div className="space-y-3 px-4 lg:px-6">
            {groupedContacts?.[letter]?.map((contact, index) => (
              <div key={contact?.id || index}>
                {renderContact(contact)}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AlphabeticalSections;